/**
 * An address no route answers to.
 *
 * Says so in a sentence and offers the way back, rather than an empty canvas: a link mistyped into a
 * ticket, or one minted for a page that has since moved, would otherwise read as the CRM failing to
 * load. The build is named because "which version were you on?" is the first question about a link
 * that worked last week.
 */
import type { Container } from 'webwin';
import { APP_VERSION } from '../version.js';
import { button, buttonRow, card, GAP, h1, muted, stackOf, vstack } from '../ui/layout.js';
import type { CrmPage, PageContext } from './page.js';

export function notFoundPage(): CrmPage {
  return {
    mount(host: Container, ctx: PageContext) {
      const shell = card();
      shell.controls.add(
        stackOf(
          vstack({ spacing: GAP.md }),
          h1('Not found'),
          muted(`No page in the CRM answers to ${window.location.pathname}. This build is ${APP_VERSION}.`),
          stackOf(buttonRow(), button('Go to customers', () => ctx.go('/customers'), true))
        )
      );
      host.controls.add(stackOf(vstack({ padding: { left: GAP.xl, top: GAP.xl, right: GAP.xl, bottom: GAP.xl } }), shell));
    }
  };
}
